import { useSelector } from 'react-redux';

export default function useNavigationGutterItems() {
  return useSelector(({ home }) => {
    const category = home.navigationItems?.categories?.find(
      (c) => c.navigationCategoryId === home.selectedCategory,
    );

    return category?.navigationGutterItems ?? [];
  });
}
